// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__69V6C","icon":"styles_icon__Tnaki","label":"styles_label__8s8BW"};